import { get, put } from "@/api/implementation/app";

export const show = (clientId) => get(`client/${clientId}/anonymize`);

export const update = (client) => put(`client/${client.id}/anonymize`, client);
